import { render, staticRenderFns } from "./VehicleFuel.vue?vue&type=template&id=5a48d35c&"
import script from "./VehicleFuel.vue?vue&type=script&lang=js&"
export * from "./VehicleFuel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports